module.exports = __webpack_public_path__ + "assets/images/$10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/$10.png
// module id = 1244
// module chunks = 1